import { RouteProp, useRoute } from '@react-navigation/native';
import { LayoutContext, ScreenSize } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import React, { useContext } from 'react';
import { BillPaymentStackParamList, BillPaymentStackRoutes } from '../../payment.navigator';
import { BillPaymentFormScheduleMobileComponent } from './BillPaymentFormScheduleMobile.component';

export const BillPaymentFormScheduleScreen: React.FC = () => {
  const layout = useContext(LayoutContext);
  const route = useRoute<RouteProp<BillPaymentStackParamList, BillPaymentStackRoutes.FormSchedule>>();
  const { detailForm, request, response, documentSelected, paymentType } = route.params;
  if (layout.screenSize === ScreenSize.Tablet || layout.isMobile) {
    return (
      <View sx={{ flex: 1 }}>
        <BillPaymentFormScheduleMobileComponent
          detailForm={detailForm}
          request={request}
          documentSelected={documentSelected}
          response={response}
          paymentType={paymentType}
        />
      </View>
    );
  }
  return <></>;
};
